export const states = [
  { stateID: 1, stateName: "Alabama" },
  { stateID: 2, stateName: "Alaska" },
  { stateID: 3, stateName: "Arizona" },
  { stateID: 4, stateName: "Arkansas" },
  { stateID: 5, stateName: "California" },
  { stateID: 6, stateName: "Colorado" },
  { stateID: 7, stateName: "Connecticut" },
  { stateID: 8, stateName: "Delaware" },
  { stateID: 9, stateName: "Florida" },
  { stateID: 10, stateName: "Georgia" },
  { stateID: 11, stateName: "Hawaii" },
  { stateID: 12, stateName: "Idaho" },
  { stateID: 13, stateName: "Illinois" },
  { stateID: 14, stateName: "Indiana" },
  { stateID: 15, stateName: "Iowa" },
  { stateID: 16, stateName: "Kansas" },
  { stateID: 17, stateName: "Kentucky" },
  { stateID: 18, stateName: "Louisiana" },
  { stateID: 19, stateName: "Maine" },
  { stateID: 20, stateName: "Maryland" },
  { stateID: 21, stateName: "Massachusetts" },
  { stateID: 22, stateName: "Michigan" },
  { stateID: 23, stateName: "Minnesota" },
  { stateID: 24, stateName: "Mississippi" },
  { stateID: 25, stateName: "Missouri" },
  { stateID: 26, stateName: "Montana" },
  { stateID: 27, stateName: "Nebraska" },
  { stateID: 28, stateName: "Nevada" },
  { stateID: 29, stateName: "New Hampshire" },
  { stateID: 30, stateName: "New Jersey" },
  { stateID: 31, stateName: "New Mexico" },
  { stateID: 32, stateName: "New York" },
  { stateID: 33, stateName: "North Carolina" },
  { stateID: 34, stateName: "North Dakota" },
  { stateID: 35, stateName: "Ohio" },
  { stateID: 36, stateName: "Oklahoma" },
  { stateID: 37, stateName: "Oregon" },
  { stateID: 38, stateName: "Pennsylvania" },
  { stateID: 39, stateName: "Rhode Island" },
  { stateID: 40, stateName: "South Carolina" },
  { stateID: 41, stateName: "South Dakota" },
  { stateID: 42, stateName: "Tennessee" },
  { stateID: 43, stateName: "Texas" },
  { stateID: 44, stateName: "Utah" },
  { stateID: 45, stateName: "Vermont" },
  { stateID: 46, stateName: "Virginia" },
  { stateID: 47, stateName: "Washington" },
  { stateID: 48, stateName: "West Virginia" },
  { stateID: 49, stateName: "Wisconsin" },
  { stateID: 50, stateName: "Wyoming" },
  { stateID: 51, stateName: "Washington D.C" },
  { stateID: 52, stateName: "Puerto Rico" }
];

const statesWithAliases = states.map(state => {
  const alphanumericOnly = state.stateName.replace(/[^a-z0-9]/gi, '');

  const formattedAlias = alphanumericOnly.charAt(0).toUpperCase() + alphanumericOnly.slice(1).toLowerCase();

  return {
    ...state,
    stateNameAlias: formattedAlias
  };
});

export const sortedStates = statesWithAliases.sort((a, b) =>
  a.stateName.localeCompare(b.stateName)
);



export const genres = [
  { genreID: 1, genreName: "Afrobeats" },
  { genreID: 2, genreName: "Alternative" },
  { genreID: 3, genreName: "Ambient" },
  { genreID: 4, genreName: "Blues" },
  { genreID: 5, genreName: "Classical" },
  { genreID: 6, genreName: "Classical Crossover" },
  { genreID: 7, genreName: "Country" },
  { genreID: 8, genreName: "Disco" },
  { genreID: 9, genreName: "Drum and Bass" },
  { genreID: 10, genreName: "Dubstep" },
  { genreID: 11, genreName: "EDM" },
  { genreID: 12, genreName: "Electronic/Dance" },
  { genreID: 13, genreName: "Folk" },
  { genreID: 14, genreName: "Funk" },
  { genreID: 15, genreName: "Gospel" },
  { genreID: 16, genreName: "Grime" },
  { genreID: 17, genreName: "Hard Rock" },
  { genreID: 18, genreName: "Heavy Metal" },
  { genreID: 19, genreName: "Hip-Hop/Rap" },
  { genreID: 20, genreName: "House" },
  { genreID: 21, genreName: "Indie" },
  { genreID: 22, genreName: "Jazz" },
  { genreID: 23, genreName: "K-Pop" },
  { genreID: 24, genreName: "Latin" },
  { genreID: 25, genreName: "Metal" },
  { genreID: 26, genreName: "New Age" },
  { genreID: 27, genreName: "Opera" },
  { genreID: 28, genreName: "Pop" },
  { genreID: 29, genreName: "Punk" },
  { genreID: 30, genreName: "R&B" },
  { genreID: 31, genreName: "Reggae" },
  { genreID: 32, genreName: "Reggaeton" },
  { genreID: 33, genreName: "Rock" },
  { genreID: 35, genreName: "Ska" },
  { genreID: 36, genreName: "Soul" },
  { genreID: 37, genreName: "Soundtrack" },
  { genreID: 38, genreName: "Techno" },
  { genreID: 39, genreName: "Trance" },
  { genreID: 40, genreName: "World Music" },
  { genreID: 41, genreName: "Salsa" },
  { genreID: 42, genreName: "Latin Pop" },
  { genreID: 43, genreName: "Latin Hip-Hop" },
  { genreID: 44, genreName: "Latin Rock" },
  { genreID: 45, genreName: "Lo-fi" },
  { genreID: 46, genreName: "Hyperpop" },
  { genreID: 47, genreName: "Dancehall" },
  { genreID: 48, genreName: "Trap" },
  { genreID: 49, genreName: "Drill" },
  { genreID: 50, genreName: "Christian" },
  { genreID: 51, genreName: "Dembow" },
  { genreID: 52, genreName: "Bachata" },
  { genreID: 53, genreName: "Merengue" },
  { genreID: 54, genreName: "Dance" }
];

export const sortedGenres = genres.sort((a, b) => a.genreName.localeCompare(b.genreName));


export interface RegionList {
  stateID: number;
  regionID: number;
  regionName: string;
}


const regionList: RegionList[] = [
  { stateID: 1, regionID: 1, regionName: "North Alabama" },
  { stateID: 1, regionID: 2, regionName: "South Alabama" },
  { stateID: 2, regionID: 3, regionName: "North Alaska" },
  { stateID: 2, regionID: 4, regionName: "South Alaska" },
  { stateID: 3, regionID: 5, regionName: "North Arizona" },
  { stateID: 3, regionID: 6, regionName: "South Arizona" },
  { stateID: 4, regionID: 7, regionName: "North Arkansas" },
  { stateID: 4, regionID: 8, regionName: "South Arkansas" },
  { stateID: 5, regionID: 9, regionName: "Northern California" },
  { stateID: 5, regionID: 10, regionName: "Central California" },
  { stateID: 5, regionID: 11, regionName: "Southern California" },
  { stateID: 6, regionID: 12, regionName: "East Colorado" },
  { stateID: 6, regionID: 13, regionName: "West Colorado" },
  { stateID: 7, regionID: 14, regionName: "North Connecticut" },
  { stateID: 7, regionID: 15, regionName: "South Connecticut" },
  { stateID: 8, regionID: 16, regionName: "North Delaware" },
  { stateID: 8, regionID: 17, regionName: "South Delaware" },
  { stateID: 9, regionID: 18, regionName: "North Florida" },
  { stateID: 9, regionID: 19, regionName: "South Florida" },
  { stateID: 10, regionID: 20, regionName: "North Georgia" },
  { stateID: 10, regionID: 21, regionName: "South Georgia" },
  { stateID: 11, regionID: 22, regionName: "Hawaii Island" },
  { stateID: 11, regionID: 23, regionName: "Maui Island" },
  { stateID: 11, regionID: 24, regionName: "Oahu Island" },
  { stateID: 11, regionID: 25, regionName: "Kauai Island" },
  { stateID: 12, regionID: 26, regionName: "North Idaho" },
  { stateID: 12, regionID: 27, regionName: "South Idaho" },
  { stateID: 13, regionID: 28, regionName: "North Illinois" },
  { stateID: 13, regionID: 29, regionName: "South Illinois" },
  { stateID: 14, regionID: 30, regionName: "North Indiana" },
  { stateID: 14, regionID: 31, regionName: "South Indiana" },
  { stateID: 15, regionID: 32, regionName: "North Iowa" },
  { stateID: 15, regionID: 33, regionName: "South Iowa" },
  { stateID: 16, regionID: 34, regionName: "North Kansas" },
  { stateID: 16, regionID: 35, regionName: "South Kansas" },
  { stateID: 17, regionID: 36, regionName: "East Kentucky" },
  { stateID: 17, regionID: 37, regionName: "West Kentucky" },
  { stateID: 18, regionID: 38, regionName: "North Louisiana" },
  { stateID: 18, regionID: 39, regionName: "South Louisiana" },
  { stateID: 19, regionID: 40, regionName: "North Maine" },
  { stateID: 19, regionID: 41, regionName: "South Maine" },
  { stateID: 20, regionID: 42, regionName: "North Maryland" },
  { stateID: 20, regionID: 43, regionName: "South Maryland" },
  { stateID: 21, regionID: 44, regionName: "East Massachusetts" },
  { stateID: 21, regionID: 45, regionName: "West Massachusetts" },
  { stateID: 22, regionID: 46, regionName: "East Michigan" },
  { stateID: 22, regionID: 47, regionName: "West Michigan" },
  { stateID: 22, regionID: 48, regionName: "Northern Michigan" },
  { stateID: 22, regionID: 49, regionName: "Upper Peninsula Michigan" },
  { stateID: 23, regionID: 50, regionName: "North Minnesota" },
  { stateID: 23, regionID: 51, regionName: "South Minnesota" },
  { stateID: 24, regionID: 52, regionName: "North Mississippi" },
  { stateID: 24, regionID: 53, regionName: "South Mississippi" },
  { stateID: 25, regionID: 54, regionName: "North Missouri" },
  { stateID: 25, regionID: 55, regionName: "South Missouri" },
  { stateID: 26, regionID: 56, regionName: "East Montana" },
  { stateID: 26, regionID: 57, regionName: "West Montana" },
  { stateID: 27, regionID: 58, regionName: "East Nebraska" },
  { stateID: 27, regionID: 59, regionName: "West Nebraska" },
  { stateID: 28, regionID: 60, regionName: "North Nevada" },
  { stateID: 28, regionID: 61, regionName: "South Nevada" },
  { stateID: 29, regionID: 62, regionName: "North New Hampshire" },
  { stateID: 29, regionID: 63, regionName: "South New Hampshire" },
  { stateID: 30, regionID: 64, regionName: "North New Jersey" },
  { stateID: 30, regionID: 65, regionName: "South New Jersey" },
  { stateID: 31, regionID: 66, regionName: "North New Mexico" },
  { stateID: 31, regionID: 67, regionName: "South New Mexico" },
  { stateID: 32, regionID: 68, regionName: "Burroughs New York" },
  { stateID: 32, regionID: 69, regionName: "East New York" },
  { stateID: 32, regionID: 70, regionName: "Long Island New York" },
  { stateID: 32, regionID: 71, regionName: "West New York" },
  { stateID: 33, regionID: 72, regionName: "Eastern North Carolina" },
  { stateID: 33, regionID: 73, regionName: "Western North Carolina" },
  { stateID: 34, regionID: 74, regionName: "Northern North Dakota" },
  { stateID: 34, regionID: 75, regionName: "Southern North Dakota" },
  { stateID: 35, regionID: 76, regionName: "East Ohio" },
  { stateID: 35, regionID: 77, regionName: "West Ohio" },
  { stateID: 36, regionID: 78, regionName: "North Oklahoma" },
  { stateID: 36, regionID: 79, regionName: "South Oklahoma" },
  { stateID: 37, regionID: 80, regionName: "East Oregon" },
  { stateID: 37, regionID: 81, regionName: "West Oregon" },
  { stateID: 38, regionID: 82, regionName: "East Pennsylvania" },
  { stateID: 38, regionID: 83, regionName: "West Pennsylvania" },
  { stateID: 39, regionID: 84, regionName: "North Rhode Island" },
  { stateID: 39, regionID: 85, regionName: "South Rhode Island" },
  { stateID: 40, regionID: 86, regionName: "Northern South Carolina" },
  { stateID: 40, regionID: 87, regionName: "Southern South Carolina" },
  { stateID: 41, regionID: 88, regionName: "Eastern South Dakota" },
  { stateID: 41, regionID: 89, regionName: "Western South Dakota" },
  { stateID: 42, regionID: 90, regionName: "East Tennessee" },
  { stateID: 42, regionID: 91, regionName: "West Tennessee" },
  { stateID: 43, regionID: 92, regionName: "East Texas" },
  { stateID: 43, regionID: 93, regionName: "North Texas" },
  { stateID: 43, regionID: 94, regionName: "South Texas" },
  { stateID: 43, regionID: 95, regionName: "West Texas" },
  { stateID: 44, regionID: 96, regionName: "North Utah" },
  { stateID: 44, regionID: 97, regionName: "South Utah" },
  { stateID: 45, regionID: 98, regionName: "North Vermont" },
  { stateID: 45, regionID: 99, regionName: "South Vermont" },
  { stateID: 46, regionID: 100, regionName: "North Virginia" },
  { stateID: 46, regionID: 101, regionName: "South Virginia" },
  { stateID: 47, regionID: 102, regionName: "East Washington" },
  { stateID: 47, regionID: 103, regionName: "West Washington" },
  { stateID: 48, regionID: 104, regionName: "Northern West Virginia" },
  { stateID: 48, regionID: 105, regionName: "Southern West Virginia" },
  { stateID: 49, regionID: 106, regionName: "North Wisconsin" },
  { stateID: 49, regionID: 107, regionName: "South Wisconsin" },
  { stateID: 50, regionID: 108, regionName: "East Wyoming" },
  { stateID: 50, regionID: 109, regionName: "West Wyoming" },
  { stateID: 51, regionID: 110, regionName: "North Washington D.C" },
  { stateID: 51, regionID: 111, regionName: "South Washington D.C" },
  { stateID: 52, regionID: 112, regionName: "West Puerto Rico" },
  { stateID: 52, regionID: 113, regionName: "East Puerto Rico" },
];


export const sortedRegions = regionList.sort((a, b) => a.regionName.localeCompare(b.regionName));

export const getRegionUrlParam = (name: string) => {
  const stripped = name.replace(/\s+/g, '').toLowerCase();
  return stripped.charAt(0).toUpperCase() + stripped.slice(1);
};